/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './NoteText.style';

type Props = {
  layoutClass?: string,
  onLightBg?: boolean,
  children: React.Node,
};

const useStyles = createUseStyles(styles);

const NoteText = ({ layoutClass, onLightBg, children }: Props): React.Node => {
  const classes: Object = useStyles();

  return (
    <small
      className={classNames(classes.root, layoutClass, {
        [classes['root-onLightBg']]: onLightBg,
      })}
    >
      {children}
    </small>
  );
};

export default NoteText;
